<template>
    <div :class="$common.getClassName('packagebox-index-componesnts')" v-if="!$noChannelData">
        <div :class="$common.getClassName('packagebox-1')" v-if="$modulList.packagelist === 1">
            <Packagebox1></Packagebox1>
        </div>
    </div>
</template>

<script>

    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
    import Packagebox1 from './Packagebox1';


    export default {
        name: 'packageBox',
        components: {
            Packagebox1
        },
        data() {
            return {};
        },
        computed: {
            ...mapState(['$modulList','$noChannelData', '$common']),
            ...mapState('Module_Access', ['userAccessStatus']),
        },

        watch: {
            userAccessStatus: function (val) {
                if (val === true) {
                    //加载渠道套餐详情
                    this.GET_PACKAGE_LIST_INFO();

                    //加载用户最后支付渠道
                    this.GET_USER_LAST_PAY_INFO();
                }
            },
        },

        methods: {
            ...mapActions('Module_Package', ['GET_PACKAGE_LIST_INFO', 'GET_USER_LAST_PAY_INFO']),
        }
    };
</script>
<style type="scss">

</style>



// WEBPACK FOOTER //
// website/components/packagebox/Index.vue